<template>
  <v-fade-transition mode="out-in">
        <v-select
        v-model="selectedLang"
        :items="$getAvailableLanguages()"
        item-value="code"
        item-text="name"
        density="compact"
        hide-details
        class="lang-switcher mx-4"
        @change="changeLanguage"
        >
        <template v-slot:selection="{ item }">
            <img
                :src="require(`@/assets/flags/${item.code}.png`)"
                alt=""
                class="lang-flag"
            />
        </template>
        <template v-slot:item="{ item }">
            <div class="d-flex align-center">
            <img
                :src="require(`@/assets/flags/${item.code}.png`)"
                alt=""
                class="lang-flag me-2"
            />
            <span>{{ item.text }}</span>
            </div>
        </template>
        </v-select>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'

export default {
    data() {
        return {
        selectedLang: null,
        };
    },
    methods: {
        changeLanguage(lang) {
        this.$i18n.locale = lang;
        this.$setDocumentLangDir(lang);
        },
    },
    mounted() {
        this.selectedLang = this.$i18n.locale;
    }
}
</script>
<style scoped>
.lang-switcher {
  max-width: 56px;
}
.lang-switcher ::v-deep .v-input__slot {
  min-height: 36px !important;
  padding: 0 10px !important;
  border-radius: 999px !important;
}
.lang-flag {
  width: 28px;
  height: 19px;
  border-radius: 3px;
  object-fit: cover;
  display: block;
}
</style>
